/* =================== CADASTRO =================== */
jQuery(document).ready(function ($) {
  var enviando_formulario = false;
  $("#form-cadastro").on("submit", function (e) {
    e.preventDefault();

    var obj = this;
    var form = $(obj);
    var submit_btn = $("#cadastrar");
    var submit_btn_text = submit_btn.text();
    var dados = new FormData(obj);

    function volta_submit() {
      submit_btn.attr("disabled", false);
      submit_btn.text(submit_btn_text);
      enviando_formulario = false;
      //hideLoading();
    }

    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          //showLoading();
          enviando_formulario = true;
          submit_btn.attr("disabled", true);
          submit_btn.text("Aguarde...");
        },
        success: function (data) {
          console.log(data);
          volta_submit();
          if (data == "ok") {
            $("#form-cadastro .campo").val("");
            window.location.href = $("#cadastro_retorno").val();
          } else {
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        },
      });
    }
  });

  function validaCod() {
    var obj = $('#form-cadastro');
    var dados = new FormData(obj[0]);
    $.ajax({
      type: "POST",
      url: url_base + 'acoes/app/usuarios/valida_cod_envia.php',
      data: dados,
      processData: false,
      cache: false,
      contentType: false,
      success: function (resposta) {
        console.log(resposta);
        if (resposta == "ok") {
          showAlert(
            "Sucesso",
            "Código válidado com sucesso! <br> Continue com a criação da conta.",
            "success"
          );
        } else {
          showAlert(
            "Erro",
            "Código inválido, confirme o código enviado para o seu e-mail e tente novamente.",
            "error"
          );
        }
      }
    });
  }

  function enviaCodCad() {
    var obj = $('#form-cadastro');
    var dados = new FormData(obj[0]);
    $.ajax({
      type: "POST",
      url: url_base + 'acoes/app/usuarios/cod_email_envia_cad.php',
      data: dados,
      processData: false,
      cache: false,
      contentType: false,
      success: function (resposta) {
        //console.log(resposta);
      }
    });
  }

  var intervals = [];
  function ativaTimerCad() {
    $("#tempo-cad").html('60');
    $("#frase-codigo-cad").show();
    $("#reeviar-cod-cad").hide();
    var counter = 60;
    var interval = setInterval(function () {
      counter--;
      if (counter <= 0) {
        clearInterval(interval);
        $("#frase-codigo-cad").hide();
        $("#reeviar-cod-cad").show();
        return;
      } else {
        $("#tempo-cad").text(counter);
      }
    }, 1000);
    intervals.push(interval);
  }

  $('#validar-cod-cad').on('click', function (e) {
    validaCod();
  });

  $('#reeviar-cod-cad').on('click', function (e) {
    enviaCodCad();
    intervals.forEach(clearInterval);
    ativaTimerCad();
  });

  $('.valideemailcad').on('change', function (e) {
    var obj = $('#form-cadastro');
    var dados = new FormData(obj[0]);
    $.ajax({
      type: "POST",
      url: url_base + 'acoes/app/usuarios/valida_email_conta_cad.php',
      data: dados,
      processData: false,
      cache: false,
      contentType: false,
      success: function (resposta) {
        console.log(resposta);
        if (resposta == 'ok') {
          $('#step-auth-cad').show();
          enviaCodCad();
          intervals.forEach(clearInterval);
          ativaTimerCad();
        } else {
          $('#step-auth-cad').hide();
          $("#reeviar-cod-cad").hide();
          $("#campo1-cad").val('');
          showAlert(
            "Erro",
            "Já existe uma conta cadastrada com esse endereço de e-mail.",
            "error"
          );
        }
      }
    });
  });

});
